import React, { useState, useRef } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { requestResetPassword } from '../services/AuthService'; // Méthode du service
import { validateEmail } from '../services/Validation';  // Importer la fonction de validation
import { useTranslation } from 'react-i18next';
import '../css/forms.css';

const ForgotPasswordModal = ({ show, handleClose }) => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');  // Pour stocker l'erreur de validation
  const { t } = useTranslation();
  const emailRef = useRef(null);

  const handleResetPassword = async () => {
    // Valider l'email
    const emailValidation = validateEmail(email);

    // Si l'email est invalide, afficher l'erreur et arrêter l'envoi
    if (!emailValidation.valid) {
      setError(emailValidation.error);
      return;
    }

    // Réinitialiser l'erreur si l'email est valide
    setError('');

    try {
      const responseMessage = await requestResetPassword(email);
      setMessage(responseMessage);
    } catch (error) {
      setMessage(error.message || 'Erreur lors de la demande de réinitialisation');
    }
  };

  return (
    <Modal show={show}
      onHide={handleClose}
      restoreFocus={false}
      onEntered={() => {
        emailRef.current?.focus();
      }}
    >
      <Modal.Header>
        <Modal.Title>{t('modal.requestresetpw.title')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group controlId="formEmail">
            <Form.Label>{t('modal.requestresetpw.email.value')}</Form.Label>
            <Form.Control
              type="email"
              placeholder={t('modal.requestresetpw.email.default')}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              isInvalid={!!error}  // Si une erreur est présente, l'input sera marqué comme invalide
              ref={emailRef}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  handleResetPassword();
                }
              }}
            />
            <Form.Control.Feedback type="invalid">
              {error}  {/* Affichage du message d'erreur */}
            </Form.Control.Feedback>
          </Form.Group>
          <Button variant="primary" onClick={handleResetPassword}>
            {t('modal.requestresetpw.send')}
          </Button>
        </Form>
        {message && (
              <p
                style={{
                  marginTop: '10px',
                  color: '#ff4d4f',        // rouge vif pour l’erreur
                  fontWeight: 'bold',      // un peu plus visible
                  padding: '8px 12px',
                  borderRadius: '5px',
                }}
              >
                {message}
              </p>
            )}
      </Modal.Body>
    </Modal>
  );
};

export default ForgotPasswordModal;
